import React from 'react';
import { Bars3Icon, UserCircleIcon } from '@heroicons/react/24/outline';

export default function Header({ sidebarOpen, setSidebarOpen, employee, onLogout }) {
  return (
    <div className="navbar bg-base-100 shadow-md z-10">
      <div className="flex-none lg:hidden">
        <button
          type="button"
          className="btn btn-square btn-ghost"
          onClick={() => setSidebarOpen(true)}
        >
          <span className="sr-only">Open sidebar</span>
          <Bars3Icon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      
      <div className="flex-1">
        {/* Add search or other content here */}
      </div>

      <div className="flex-none">
        <div className="dropdown dropdown-end">
          <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
            <UserCircleIcon className="h-8 w-8" />
          </label>
          <ul tabIndex={0} className="mt-3 z-[1] p-2 shadow menu menu-sm dropdown-content bg-base-100 rounded-box w-52">
            <li className="menu-title px-4 py-2">
              <span>{employee?.name}</span>
            </li>
            <div className="divider my-0"></div>
            <li>
              <button onClick={onLogout} className="text-error">
                Sign out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
} 